<template>
  <div>
    <h6 class="text-start">
        <b>
          <slot />
        </b>
    </h6>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>